import { createSlice } from '@reduxjs/toolkit'
const msbank = "/assets/images/sliders/msbank.jpg";
const uxtech = "/assets/images/sliders/uxtech.jpg";
const abaafashab = "/assets/images/sliders/abaafashab.jpg";
const bsc = "/assets/images/sliders/bsc.jpg";

const sliderSlice = createSlice({
    name: 'slider',
    initialState: {
      sliders: [
        {
          img: abaafashab,
          title: 'ACCOUNTING AND FINANCE SERVICES COMPANY PORTAL AND OPERATION MANAGEMENT SYSTEM.',
          url: 'abaafashab.uxtech.ng'
        },
        {
          img: msbank,
          title: 'fin-Tech Company Banking Web and Mobile Application.',
          url: 'www.uxtech.ng'
        },
        {
          img: uxtech,
          title: 'TELECOMMUNICATION AUTOMATED SERVICES MANAGEMENT SYSTEM (Mobile and Web).',
          url: 'www.uxtech.ng'
        },
        {
          img: bsc,
          title: 'Bida Sport Club Portal and Members Management System.',
          url: 'www.uxtech.ng'
        },
        // {
        //   img: img1,
        //   title: 'Image 1'
        // },
      ]
    }
    ,
    reducers: {
        updateSlider: (state, action) => {
            state.sliders = action.payload;
        }
    }
})

export const {updateSlider} = sliderSlice.actions;
export default sliderSlice.reducer;
